import type { EPGEntryId } from "@sunrise/backend-types-core";
import type { Nullable } from "@sunrise/utils";

export const queryKeys = {
  epgById: (epgId: Nullable<EPGEntryId>) => ["epg", epgId],
};
